import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["0"];
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Amplitude from "@Shared/utils/amplitude";
import GenericModal from "@Shared/components/modals/generic-modal.vue";
import DefaultFooterLoader from "@Shared/components/modals/generic-modal-loaders/default-footer-loader.vue";
import PreviousRequestedPackagesStep from "./bulk-request-steps/previous-requested-packages-step.vue";
import ChoseFlowStep from "./bulk-request-steps/chose-flow-step.vue";
import RequestApplicationDetails from "./bulk-request-steps/request-application-details-step.vue";
import RequestDocumentsStep from "./bulk-request-steps/request-documents-step.vue";
import RequestBankStatementsStep from "./bulk-request-steps/request-bank-statements-step.vue";
import PreviewEmailStep from "./bulk-request-steps/preview-email-step.vue";
import CustomizeMessageStep from "./bulk-request-steps/customize-message-step.vue";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import BulkRequestModalLoader from "./bulk-request-modal-loader.vue";
import { DOCUMENTS_CLASSIFICATIONS_FOR_APPLICATION } from "../../../documents/store/documents-getters";
import { LOAD_CLIENT_REQUEST_EMAIL_DATA, CREATE_REQUEST_PACKAGE, LOAD_PREVIEW_REQUEST_PACKAGE, LOAD_REQUESTED_PACKAGES } from "../../store/application-actions";
import { LOAD_DOCUMENTS, LOAD_DOCUMENT_REQUEST_EMAIL_TEMPLATES, LOAD_DOCUMENT_REQUEST_EMAIL_TEMPLATE, UPDATE_DOCUMENT_REQUEST_EMAIL_TEMPLATE, DELETE_DOCUMENT_REQUEST_EMAIL_TEMPLATE, CREATE_DOCUMENT_REQUEST_EMAIL_TEMPLATE, UPDATE_DOCUMENT_CLASSIFICATION_SENT_STATUS } from "../../../documents/store/documents-actions";
import { mapState, mapActions, mapGetters } from "vuex";
import { mapFields } from "@joandvgv/vuex-map-fields";
import SpinnerLoader from "@Shared/utils/preload";
import { showToast } from "@Shared/utils/constants";
import PlanSimpleButton from "@Broker/@Modules/account-plan/components/account-plan-usage/plan-simple-button.vue";
import { ACCOUNT_PLAN_PAGE } from "@Broker/@Utils/enum";
import AccountUsageBanner from "@Broker/@Modules/account-plan/components/account-plan-usage/account-usage-banner.vue";
import { LOAD_PLAN_LIMITS } from "@Broker/@Modules/account-plan/store/account-plan-actions";
import { CURRENT_APPLICATION, CURRENT_APPLICATION_APPLICANTS, CURRENT_APPLICATION_REQUESTED_PACKAGES } from "../../store/application-getters";
import { formatApplicantsData } from "@Shared/@Utils/utils";
import { Fragment } from "vue-fragment";
import { cloneDeep, filter, forEach, isEmpty, reduce } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "BulkRequestModal",
  components: {
    PreviousRequestedPackagesStep,
    ChoseFlowStep,
    RequestApplicationDetails,
    RequestDocumentsStep,
    RequestBankStatementsStep,
    PreviewEmailStep,
    CustomizeMessageStep,
    GenericModal,
    SimpleButton,
    BulkRequestModalLoader,
    PlanSimpleButton,
    AccountUsageBanner,
    DefaultFooterLoader,
    Fragment
  },
  props: {
    clientUsername: {
      type: String,
      required: true
    },
    applicationId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      stepsRendering: {
        previousRequestedPackages: {
          component: "previous-requested-packages-step",
          includedInPath: true,
          dataKey: "",
          nextStepTitle: this.$t("application.applicationHeader.createRequestPackage")
        },
        choseFlow: {
          component: "chose-flow-step",
          includedInPath: true,
          dataKey: "emailToSend"
        },
        requestApplicationDetails: {
          component: "request-application-details",
          includedInPath: false,
          dataKey: "applicationDetails",
          stepTitle: this.$t("request-package.steps.requestApplicationDetails")
        },
        requestDocuments: {
          component: "request-documents-step",
          includedInPath: false,
          dataKey: "documentRequestIds",
          stepTitle: this.$t("request-package.steps.requestDocuments")
        },
        requestBankStatements: {
          component: "request-bank-statements-step",
          includedInPath: false,
          dataKey: "bankStatements",
          stepTitle: this.$t("request-package.steps.requestBankStatements"),
          planPageKey: "BANK_STATEMENT"
        },
        customizeMessage: {
          component: "customize-message-step",
          includedInPath: true,
          dataKey: "userMessage",
          stepTitle: this.$t("request-package.steps.customizeEmailMessage"),
          nextStepTitle: this.$t("request-package.steps.previewEmail")
        },
        previewEmail: {
          component: "preview-email-step",
          includedInPath: true,
          dataKey: "userMessage",
          stepTitle: this.$t("request-package.steps.previewEmailToSendToClient"),
          previousStepTitle: this.$t("request-package.steps.customizeMessage")
        }
      },
      stepsData: {
        emailToSend: "",
        documentRequestIds: [],
        bankStatements: {
          emails: [],
          months: 12
        },
        userMessage: ""
      },
      emptyStepData: {},
      currentStepNumber: 0,
      isCurrentStepValid: false,
      sendingEmail: {
        loading: false,
        status: true
      },
      includeSendApplication: false,
      includeBankStatements: false,
      errorsChecked: false,
      autoSelectedEmailTemplate: "",
      previewEmail: "",
      selectedApplicantsByDocumentRequestIds: {},
      applicationDetails: {
        personalInformationForMainApplicant: [],
        selectedProperty: 0,
        selectedMortgageDetails: 0
      },
      loadingInitialData: true,
      lastReqClients: [],
      lastCoapp: [],
      activeClientUsername: ""
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapFields("ApplicationStore", ["clientRequestEmail"])), mapState("ApplicationStore", {
    accountIsGhost(state) {
      var _state$clients$this$c;
      return ((_state$clients$this$c = state.clients[this.clientUsername]) == null ? void 0 : _state$clients$this$c.accountStatus) === "ghost";
    }
  })), mapState("DocumentsStore", ["documents", "documentRequestTemplates"])), mapState("AccountStore", ["userDetails"])), mapGetters("DocumentsStore", [DOCUMENTS_CLASSIFICATIONS_FOR_APPLICATION])), mapGetters("ApplicationStore", [CURRENT_APPLICATION_APPLICANTS, CURRENT_APPLICATION_REQUESTED_PACKAGES, CURRENT_APPLICATION])), {}, {
    computedStepsRendering() {
      return _objectSpread(_objectSpread({}, this.stepsRendering), {}, {
        previousRequestedPackages: _objectSpread(_objectSpread({}, this.stepsRendering.previousRequestedPackages), {}, {
          includedInPath: !isEmpty(this.previousRequestedPackages)
        }),
        requestApplicationDetails: _objectSpread(_objectSpread({}, this.stepsRendering.requestApplicationDetails), {}, {
          stepTitle: this.$t("request-package.steps.requestApplicationDetails")
        }),
        requestDocuments: _objectSpread(_objectSpread({}, this.stepsRendering.requestDocuments), {}, {
          stepTitle: this.$t("request-package.steps.requestDocuments")
        }),
        requestBankStatements: _objectSpread(_objectSpread({}, this.stepsRendering.requestBankStatements), {}, {
          stepTitle: this.$t("request-package.steps.requestBankStatements")
        }),
        customizeMessage: _objectSpread(_objectSpread({}, this.stepsRendering.customizeMessage), {}, {
          stepTitle: this.$t("request-package.steps.customizeEmailMessage"),
          nextStepTitle: this.$t("request-package.steps.previewEmail")
        }),
        previewEmail: _objectSpread(_objectSpread({}, this.stepsRendering.previewEmail), {}, {
          stepTitle: this.$t("request-package.steps.previewEmailToSendToClient"),
          previousStepTitle: this.$t("request-package.steps.customizeMessage")
        })
      });
    },
    allStepsKeys() {
      return _Object$keys(this.computedStepsRendering);
    },
    wizardPath() {
      return filter(this.allStepsKeys, step => this.computedStepsRendering[step].includedInPath);
    },
    currentStepKey() {
      return this.wizardPath[this.currentStepNumber];
    },
    currentStepRenderingInfo() {
      return this.computedStepsRendering[this.currentStepKey];
    },
    showPreviousButton() {
      return this.currentStepNumber > 0;
    },
    isLastStep() {
      return this.currentStepNumber + 1 === this.wizardPath.length;
    },
    nextButtonText() {
      return this.isLastStep ? this.$t("global.actions.sendEmail") : this.currentStepRenderingInfo.nextStepTitle || this.$t("request-package.steps.nextStep");
    },
    previousButtonText() {
      return this.currentStepRenderingInfo.previousStepTitle || this.$t("request-package.steps.previousStep");
    },
    currentStepTitle() {
      return this.currentStepRenderingInfo.stepTitle || this.$t("request-package.steps.clientRequestPackage");
    },
    modalBodyClass() {
      return `px-4 py-3 overflow-auto ${this.currentStepRenderingInfo.component}`;
    },
    documentClassifications() {
      return _Object$values(this.DOCUMENTS_CLASSIFICATIONS_FOR_APPLICATION(this.applicationId).byId);
    },
    documentClassificationsIds() {
      return this.DOCUMENTS_CLASSIFICATIONS_FOR_APPLICATION(this.applicationId).allIds;
    },
    shouldFetchDocuments() {
      return isEmpty(this.documentClassifications) && this.computedStepsRendering.requestDocuments.includedInPath;
    },
    accountPlanPage() {
      var _ACCOUNT_PLAN_PAGE$th;
      return (_ACCOUNT_PLAN_PAGE$th = ACCOUNT_PLAN_PAGE[this.computedStepsRendering[this.currentStepKey].planPageKey]) != null ? _ACCOUNT_PLAN_PAGE$th : "";
    },
    applicants() {
      var _context;
      const applicants = _mapInstanceProperty(_context = this.CURRENT_APPLICATION_APPLICANTS).call(_context, applicant => _objectSpread(_objectSpread({}, applicant), applicant["personal-details"]));
      return formatApplicantsData(applicants, applicant => applicant.applicantIndex === 0 ? this.clientUsername : applicant.id, {
        fullName: "applicantFullName"
      }, true);
    },
    previousRequestedPackages() {
      var _this$CURRENT_APPLICA, _this$CURRENT_APPLICA2;
      return _Object$values((_this$CURRENT_APPLICA = (_this$CURRENT_APPLICA2 = this.CURRENT_APPLICATION_REQUESTED_PACKAGES(this.applicationId)) == null ? void 0 : _this$CURRENT_APPLICA2.byId) != null ? _this$CURRENT_APPLICA : {});
    }
  }),
  watch: {
    shouldFetchDocuments: {
      immediate: true,
      handler(value) {
        if (!value) return;
        this.initRequestDocsData();
      }
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("AccountPlanStore", [LOAD_PLAN_LIMITS])), mapActions("ApplicationStore", [LOAD_CLIENT_REQUEST_EMAIL_DATA, CREATE_REQUEST_PACKAGE, LOAD_PREVIEW_REQUEST_PACKAGE, LOAD_REQUESTED_PACKAGES])), mapActions("DocumentsStore", [LOAD_DOCUMENTS, LOAD_DOCUMENT_REQUEST_EMAIL_TEMPLATES, LOAD_DOCUMENT_REQUEST_EMAIL_TEMPLATE, UPDATE_DOCUMENT_REQUEST_EMAIL_TEMPLATE, DELETE_DOCUMENT_REQUEST_EMAIL_TEMPLATE, CREATE_DOCUMENT_REQUEST_EMAIL_TEMPLATE, UPDATE_DOCUMENT_CLASSIFICATION_SENT_STATUS])), {}, {
    async handleShow() {
      Amplitude.logEvent("Application - Create Request Package - Modal Opened");
      this.loading = true;
      this.loadingInitialData = true;
      this.emptyStepData = cloneDeep(this.stepsData);
      this.handlePreselectedData();
      await this.initInitialData();
      this.loading = false;
      this.loadingInitialData = false;
    },
    handlePreselectedData() {
      var _modalData$preselectR, _modalData$documentRe;
      const {
        modalData
      } = this.$refs.bulkRequestModal;
      if (isEmpty(modalData)) return;
      this.stepsRendering.requestDocuments.includedInPath = (_modalData$preselectR = modalData.preselectRequestDocument) != null ? _modalData$preselectR : false;
      this.stepsData.documentRequestIds = (_modalData$documentRe = modalData.documentRequestIds) != null ? _modalData$documentRe : [];
      if (modalData.preselectRequestDocument) this.currentStepNumber = 1;
    },
    handleHidden() {
      this.resetData();
    },
    closeModal() {
      this.$nextTick(() => {
        this.$refs.bulkRequestModal.hide();
      });
    },
    resetData() {
      this.stepsData = {
        emailToSend: "",
        documentRequestIds: [],
        bankStatements: {
          emails: [],
          months: 12
        },
        userMessage: ""
      };
      this.currentStepNumber = 0;
      this.isCurrentStepValid = false;
      //TODO: maybe add a 'default: true' key to the stepsRendering object, to reset these values generically
      this.stepsRendering.requestApplicationDetails.includedInPath = false;
      this.stepsRendering.requestDocuments.includedInPath = false;
      this.stepsRendering.requestBankStatements.includedInPath = false;
      this.includeSendApplication = false;
      this.includeBankStatements = false;
      this.autoSelectedEmailTemplate = "";
      this.$refs.bulkRequestModal.modalData = {};
      this.initApplicantsData();
      this.logAmplitude("Reset Steps Data");
    },
    async createRequestPackage() {
      try {
        var _context2;
        const parsedApplicantsData = this.parseApplicantsData();
        this.sendingEmail.loading = true;
        await this.CREATE_REQUEST_PACKAGE({
          applicationId: this.applicationId,
          clientUsername: this.clientUsername,
          payload: _objectSpread(_objectSpread({}, this.stepsData), {}, {
            bankStatements: {
              emails: this.includeBankStatements ? [..._mapInstanceProperty(_context2 = this.stepsData.bankStatements.emails).call(_context2, request => request.email), this.stepsData.emailToSend] : [],
              months: this.stepsData.bankStatements.months
            },
            share: this.includeSendApplication
          }, parsedApplicantsData)
        });
        const {
          documentRequestIds
        } = this.stepsData;
        if (documentRequestIds.length) {
          documentRequestIds.forEach(documentRequestId => this.UPDATE_DOCUMENT_CLASSIFICATION_SENT_STATUS({
            applicationId: this.applicationId,
            documentRequestId,
            sent: true
          }));
        }
        showToast("success", "requestPackageCreated");
        this.$refs.bulkRequestModal.hide();
        this.logAmplitude("Request Package completed");
      } catch (e) {
        this.sendingEmail.status = false;
        this.logAmplitude("Request Package failed");
      } finally {
        this.sendingEmail.loading = false;
        SpinnerLoader.stop();
      }
    },
    checkStepsData() {
      forEach(this.computedStepsRendering, (step, key) => {
        var _context3;
        if (!_includesInstanceProperty(_context3 = this.wizardPath).call(_context3, key)) this.stepsData[step.dataKey] = this.emptyStepData[step.dataKey];
      });
    },
    nextStep() {
      this.currentStepNumber++;
      this.isCurrentStepValid = false;
      this.logAmplitude("Next Step");
    },
    previousStep() {
      this.currentStepNumber--;
      this.isCurrentStepValid = false;
      this.logAmplitude("Previous Step");
    },
    async handleSubmit() {
      if (this.isLastStep) {
        this.createRequestPackage();
      } else {
        if (this.$refs.component && this.$refs.component.$refs.emailEditor) {
          this.handleAddEmailUserMessage(this.$refs.component.$refs.emailEditor.getHTML());
        }
        this.checkStepsData();
        this.nextStep();
      }
    },
    handleValid(valid) {
      this.isCurrentStepValid = valid;
    },
    checkForErrors(value) {
      this.errorsChecked = value;
    },
    async loadRequestedPackages() {
      await this.LOAD_REQUESTED_PACKAGES({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId
      });
      if (this.currentStepKey === "previousRequestedPackages") {
        var _this$previousRequest, _this$previousRequest2;
        this.lastCoapp = this.previousRequestedPackages[0].metadata.coApplicants;
        this.lastReqClients = (_this$previousRequest = (_this$previousRequest2 = this.previousRequestedPackages[0].metadata.fillOut[2]) == null ? void 0 : _this$previousRequest2.applicants) != null ? _this$previousRequest : [];
        if (this.previousRequestedPackages[0].metadata.activeClientUsername) {
          this.activeClientUsername = this.previousRequestedPackages[0].metadata.activeClientUsername;
        }
      }
    },
    async initInitialData() {
      await _Promise.all([this.LOAD_PLAN_LIMITS(), this.initClientRequestEmailData(), this.loadRequestedPackages()]);
      this.initDocumentRequestTemplatesData();
      this.initApplicantsData();
    },
    async initClientRequestEmailData() {
      await this.LOAD_CLIENT_REQUEST_EMAIL_DATA({
        applicationId: this.applicationId,
        clientUsername: this.clientUsername
      });
      this.stepsData.emailToSend = this.clientRequestEmail || "";
      this.stepsData.bankStatements.emails = [];
      this.logAmplitude("Loaded Client Request Email Data");
    },
    async initDocumentRequestTemplatesData() {
      await this.LOAD_DOCUMENT_REQUEST_EMAIL_TEMPLATES("consolidated-request");
      this.logAmplitude("Loaded Document Request Templates");
    },
    async initRequestDocsData() {
      this.loading = true;
      await this.LOAD_DOCUMENTS({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId
      });
      this.initApplicantsData();
      this.loading = false;
      this.logAmplitude("Loaded Documents Request Data");
    },
    handleSelectEmailRequest(email) {
      this.stepsData.emailToSend = email;
    },
    handleSelectDocumentRequest(documentRequest) {
      var _context4;
      const alreadySelected = _includesInstanceProperty(_context4 = this.stepsData.documentRequestIds).call(_context4, documentRequest);
      if (alreadySelected) {
        var _context5;
        this.stepsData.documentRequestIds = _filterInstanceProperty(_context5 = this.stepsData.documentRequestIds).call(_context5, request => request !== documentRequest);
      } else {
        this.stepsData.documentRequestIds.push(documentRequest);
      }
      this.logAmplitude("Selected Document Request");
    },
    handleSelectAllDocumentRequests(select) {
      this.stepsData.documentRequestIds = select ? this.documentClassificationsIds : [];
    },
    handleAddBankStatementRequest(emails) {
      this.stepsData.bankStatements.emails = emails;
      this.logAmplitude("Added Bank Statement Request Email");
    },
    handleDeleteBankStatementRequest(index) {
      var _context6;
      _spliceInstanceProperty(_context6 = this.stepsData.bankStatements.emails).call(_context6, index, 1);
      this.logAmplitude("Removed Bank Statement Request Email");
    },
    handleAddEmailUserMessage(message) {
      this.stepsData.userMessage = message;
    },
    async handleSelectEmailTemplate(templateId) {
      if (templateId) {
        this.loading = true;
        await this.LOAD_DOCUMENT_REQUEST_EMAIL_TEMPLATE(templateId);
        this.loading = false;
        this.logAmplitude("Selected Email Template", {
          templateId
        });
      }
      this.autoSelectedEmailTemplate = templateId != null ? templateId : "";
      this.stepsData.userMessage = templateId ? this.documentRequestTemplates.byId[templateId].html : "";
    },
    async handleUpdateEmailTemplate({
      templateId,
      name
    }) {
      this.loading = true;
      await this.UPDATE_DOCUMENT_REQUEST_EMAIL_TEMPLATE({
        templateId,
        name,
        newHtml: this.stepsData.userMessage
      });
      this.loading = false;
      this.logAmplitude("Updated Email Template", {
        templateId
      });
    },
    async handleDeleteEmailTemplate(templateId) {
      this.loading = true;
      await this.DELETE_DOCUMENT_REQUEST_EMAIL_TEMPLATE(templateId);
      this.loading = false;
      this.stepsData.userMessage = "";
      this.logAmplitude("Deleted Email Template", {
        templateId
      });
    },
    async handleCreateEmailTemplate(newTemplateName) {
      this.loading = true;
      const templateId = await this.CREATE_DOCUMENT_REQUEST_EMAIL_TEMPLATE({
        newTemplateName,
        templateHtml: this.stepsData.userMessage,
        templateType: "consolidated-request"
      });
      this.autoSelectedEmailTemplate = templateId;
      this.loading = false;
      this.logAmplitude("Created Email Template", {
        newTemplateName,
        templateId
      });
    },
    handleIncludeSendApplication(value) {
      this.includeSendApplication = value;
      this.stepsRendering.requestApplicationDetails.includedInPath = value;
    },
    handleIncludeRequestDocuments(value) {
      this.stepsRendering.requestDocuments.includedInPath = value;
    },
    handleIncludeBankStatements(value) {
      this.stepsRendering.requestBankStatements.includedInPath = value;
      this.includeBankStatements = value;
    },
    handleChangeBankMonths(months) {
      this.stepsData.bankStatements.months = months;
    },
    async handleLoadPreview() {
      this.loading = true;
      const {
        body
      } = await this.LOAD_PREVIEW_REQUEST_PACKAGE({
        applicationId: this.applicationId,
        clientUsername: this.clientUsername,
        payload: _objectSpread(_objectSpread({
          share: this.includeSendApplication
        }, this.stepsData), {}, {
          bankStatements: this.includeBankStatements
        })
      });
      this.loading = false;
      this.handleValid(true);
      this.previewEmail = body;
    },
    logAmplitude() {
      // TODO> we need to re/write these
      // Amplitude.logEvent(`Application - Create Request Package - ${message}`, {
      //   data: {
      //     wizardPath: this.wizardPath,
      //     stepsData: this.stepsData,
      //     isCurrentStepValid: this.isCurrentStepValid,
      //     currentStepNumber: this.currentStepNumber,
      //     ...extraData
      //   }
      // });
    },
    initApplicantsData() {
      var _context7;
      // Sets main applicant to be the default applicant selected for each document classification
      this.documentClassifications.forEach(({
        documentRequestId
      }) => this.selectedApplicantsByDocumentRequestIds[documentRequestId] = [this.applicants[0]]);
      this.applicationDetails.selectedProperty = 0;
      this.applicationDetails.selectedMortgageDetails = 0;

      // Sets main applicant to fill out the information of every other applicant
      this.applicationDetails.personalInformationForMainApplicant = _mapInstanceProperty(_context7 = this.applicants).call(_context7, applicant => _objectSpread(_objectSpread({}, applicant), {}, {
        id: applicant.applicantIndex
      }));
    },
    handleChangeSelectedApplicants(selectedCoApplicants) {
      this.selectedApplicantsByDocumentRequestIds = selectedCoApplicants;
    },
    parseApplicantsData() {
      var _mainApplicant$docume;
      const applicantsWithApplicationDetails = this.getApplicantsWithApplicationDetails();
      const applicants = this.getApplicantsWithDocumentRequestDetails(applicantsWithApplicationDetails);
      let _cloneDeep = cloneDeep(applicants),
        {
          0: mainApplicant
        } = _cloneDeep,
        coApplicants = _objectWithoutProperties(_cloneDeep, _excluded);
      let coAppFill = [{
        key: "mortgage-details"
      }, {
        key: "property"
      }, {
        key: "personal-details",
        applicants: []
      }];
      const coApps = _Object$values(coApplicants);
      if (this.lastReqClients.length) {
        var _context8;
        if (this.lastCoapp.length < coApps.length) {
          const coAppDifference = _filterInstanceProperty(coApps).call(coApps, el => !this.lastCoapp.some(x => el.id === x.id));
          coAppDifference.forEach(el => this.lastReqClients.push(el.id));
        }
        _mapInstanceProperty(_context8 = this.applicants).call(_context8, el => {
          var _context9, _mainApplicant$fillOu, _context0, _context1;
          if (_includesInstanceProperty(_context9 = this.lastReqClients).call(_context9, el.id) && (_mainApplicant$fillOu = mainApplicant.fillOut[2]) != null && _includesInstanceProperty(_context0 = _mainApplicant$fillOu.applicants).call(_context0, el.id) && !_includesInstanceProperty(_context1 = coAppFill[2].applicants).call(_context1, el.id)) {
            coAppFill[2].applicants.push(el.id);
          }
        });
      } else {
        coAppFill = mainApplicant.fillOut;
      }
      if (!isEmpty(this.activeClientUsername)) {
        coAppFill.forEach(fill => {
          if (fill.key === "personal-details") {
            fill.applicants[0] = this.activeClientUsername;
          }
        });
      }
      return {
        coApplicants: coApps,
        fillOut: coAppFill,
        documentRequestIds: (_mainApplicant$docume = mainApplicant.documentRequestIds) != null ? _mainApplicant$docume : []
      };
    },
    /**
     * @returns applicants data with fillOut property filled
     */
    getApplicantsWithApplicationDetails() {
      var _context10;
      // only applicants with email or main applicant
      const applicantsWithEmail = _filterInstanceProperty(_context10 = this.applicants).call(_context10, applicant => !isEmpty(applicant.email) || applicant.applicantIndex === 0);
      return reduce(applicantsWithEmail, (applicantsResult, selectedApplicant) => {
        const fillOut = [];

        // Applicant is requested to fill out Mortgage Details
        if (this.applicationDetails.selectedMortgageDetails === selectedApplicant.applicantIndex) {
          fillOut.push({
            key: "mortgage-details"
          });
        }

        // Applicant is requested to fill out Property Details
        if (this.applicationDetails.selectedProperty === selectedApplicant.applicantIndex) {
          fillOut.push({
            key: "property"
          });
        }

        // Applicant is requested to fill out Personal Information of applicants
        if (selectedApplicant.applicantIndex === 0) {
          var _context11;
          fillOut.push({
            key: "personal-details",
            applicants: _mapInstanceProperty(_context11 = this.applicationDetails.personalInformationForMainApplicant).call(_context11, ({
              applicantId,
              id
            }) => applicantId || id)
          });
        } else if (this.applicationDetails.personalInformationForMainApplicant.every(({
          applicantIndex
        }) => applicantIndex !== selectedApplicant.applicantIndex)) {
          fillOut.push({
            key: "personal-details",
            applicants: [selectedApplicant.applicantId || selectedApplicant.id]
          });
        }
        applicantsResult[selectedApplicant.applicantIndex] = {
          id: selectedApplicant.id,
          applicantIndex: selectedApplicant.applicantIndex,
          email: selectedApplicant.email,
          fillOut: this.stepsRendering.requestApplicationDetails.includedInPath ? fillOut : [],
          documentRequestIds: []
        };
        return applicantsResult;
      }, {});
    },
    /**
     * @returns applicants data with documentRequestIds property filled
     */
    getApplicantsWithDocumentRequestDetails(applicants) {
      if (!this.stepsRendering.requestDocuments.includedInPath) return applicants;
      const selectedApplicantsByDocumentRequestIds = cloneDeep(this.selectedApplicantsByDocumentRequestIds);
      return reduce(selectedApplicantsByDocumentRequestIds, (applicantsResult, selectedApplicants, documentRequestId) => {
        var _context12;
        if (_includesInstanceProperty(_context12 = this.stepsData.documentRequestIds).call(_context12, documentRequestId)) {
          selectedApplicants.forEach(selectedApplicant => {
            applicantsResult[selectedApplicant.applicantIndex].documentRequestIds.push(documentRequestId);
          });
        }
        return applicantsResult;
      }, applicants);
    },
    handleChangeApplicationDetails(value) {
      this.applicationDetails = value;
    }
  })
});